export default __webpack_public_path__ + "static/foto4-735f4dd05547f7b1e64f8cac03cb8a23.jpg";